import { render } from "./video-placeholder.vue?vue&type=template&id=ef33143a&scoped=true&ts=true"
import script from "./video-placeholder.ts?vue&type=script&lang=ts&external"
export * from "./video-placeholder.ts?vue&type=script&lang=ts&external"

import "./video-placeholder.scss?vue&type=style&index=0&id=ef33143a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef33143a"]])

export default __exports__